import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/auth";

/* /smartket/terms — Public T&Cs page. Plain English on top, full
   legal below. Version-stamped so historical slips can pin to it. */

export default function SmartKetTerms() {
  const [terms, setTerms] = useState(null);

  useEffect(() => {
    document.title = "SmartKet — Terms & Conditions";
    axios.get(`${API}/smartket/terms`).then(r => setTerms(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="terms-page" className="min-h-screen bg-[#0d1410] text-white">
      <div className="border-b-2 border-[#d4a34a]/40 bg-[#141a15]">
        <div className="max-w-3xl mx-auto px-4 md:px-8 py-8">
          <Link to="/smartket" className="font-mono text-[10px] tracking-[0.4em] text-white/60 hover:text-[#d4a34a]">
            ← SMARTKET
          </Link>
          <h1 className="mt-3 font-display text-4xl md:text-5xl leading-none tracking-tight">
            THE <span className="text-[#d4a34a]">SLIP</span> AGREEMENT
          </h1>
          <div className="mt-2 font-mono text-[11px] text-white/60">
            Version {terms?.version || "…"} · effective {terms?.effective_date || "—"}
          </div>
          <p className="mt-3 font-mono text-sm text-white/75 max-w-xl">
            Every slip signed on SmartKet is a real, binding, e-signed contract. Plain English up top. Full legal below.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-8 space-y-6">
        {!terms && <div className="font-mono text-sm text-white/60">loading terms…</div>}
        {terms && (
          <>
            <section className="border-2 border-[#d4a34a]/40 bg-[#141a15] p-5">
              <div className="font-mono text-[10px] tracking-widest text-[#d4a34a] mb-3">PLAIN ENGLISH</div>
              <pre data-testid="terms-plain" className="whitespace-pre-wrap font-mono text-sm text-white/90 leading-relaxed">
{terms.plain_english}
              </pre>
            </section>

            <section className="border-2 border-white/15 bg-[#0d1410] p-5">
              <div className="font-mono text-[10px] tracking-widest text-[#d4a34a] mb-3">FULL LEGAL</div>
              <pre data-testid="terms-full" className="whitespace-pre-wrap font-mono text-xs text-white/80 leading-relaxed">
{terms.full_legal}
              </pre>
            </section>
          </>
        )}

        <div className="border border-white/10 bg-[#141a15] p-4 font-mono text-xs text-white/70">
          Questions or want to flag something legally?
          Email <a href="mailto:paul@youngtongues.com" className="text-[#d4a34a] underline">paul@youngtongues.com</a>.
        </div>
      </div>
    </div>
  );
}
